(function () {
  'use strict';

  var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (prefersReduced) return;

  var section = document.querySelector('.value-prop');
  if (!section) return;

  /* Active l'état caché du CSS : sans ce script, la section reste visible. */
  section.classList.add('vp-ready');

  /* --- Load reveals: title + tagline lines --- */
  var loadEls = section.querySelectorAll(
    '.value-prop__tagline-row .vp-reveal--scale,' +
    '.value-prop__tagline-row .vp-reveal'
  );

  requestAnimationFrame(function () {
    loadEls.forEach(function (el) { el.classList.add('is-visible'); });
  });

  /* --- Scroll reveals: quote, subtitle, cards --- */
  var scrollEls = section.querySelectorAll(
    '.value-prop__quote.vp-reveal,' +
    '.value-prop__rentabilite.vp-reveal,' +
    '.value-prop__subtitle-block.vp-reveal,' +
    '.value-prop__card.vp-reveal'
  );

  if (!scrollEls.length || !('IntersectionObserver' in window)) {
    scrollEls.forEach(function (el) { el.classList.add('is-visible'); });
    return;
  }

  /* Marge haute immense : un élément déjà passé au-dessus de l'écran compte comme
     vu. Un défilement rapide peut faire sauter un élément d'en dessous à au-dessus
     de l'écran sans qu'aucune image ne le montre dans la zone de détection :
     l'observateur ne signalait alors rien et les cartes restaient invisibles.
     Le bord bas (-40px, seuil 0.15), qui déclenche l'apparition au défilement,
     ne change pas. */
  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15, rootMargin: '100000px 0px -40px 0px' }
  );

  scrollEls.forEach(function (el) { observer.observe(el); });
})();
